import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICep } from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class CepService {
  constructor(private http: HttpClient) {}
  getAddresByCep(cep: string) {
    return this.http.get<ICep>(`https://viacep.com.br/ws/${cep}/json`);
  }
}
